import React, { useRef, useEffect } from 'react';
import { isMobile } from '@/biz/tool';
import { EmailConfirmedIcon } from '@/components/common/icon';
import { useTranslation } from 'react-i18next';
import axiosInstance from '@/apis/axiosInstance';
import { useNavigate } from 'react-router-dom';
interface Props {}

const EmailConfirmed: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const urlKey = new URLSearchParams(window.location.search).get('key');
  const hasRequested = useRef(false);
  useEffect(() => {
    if (hasRequested.current || !urlKey) {
      return;
    }
    hasRequested.current = true;

    axiosInstance.post('/influencer/edm/verifyEmail', {
      key: urlKey
    });
  }, [urlKey]);

  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <div className="md:w-[600px] px-6 bg-[#fff] rounded-3xl flex flex-col gap-6 items-center justify-center">
        <div className="flex items-center justify-center w-24 h-24 bg-[radial-gradient(ellipse_101.30%_82.76%_at_-5.16%_106.07%,_white_0%,_#F9FBFF_100%)] rounded-3xl shadow-[0px_2px_10px_0px_rgba(190,209,236,0.20)] shadow-[0px_2px_4px_0px_rgba(99,152,188,0.06)] shadow-[inset_0px_1px_2px_0px_rgba(255,255,255,1.00)] shadow-[inset_0px_0px_2px_0px_rgba(196,205,219,1.00)] shadow-[inset_0px_-3px_2px_0px_rgba(221,225,227,1.00)] border border-solid border-[#BBC3C8]">
          <EmailConfirmedIcon className="w-[50px] h-[50px]" />
        </div>
        <div className="self-stretch text-center justify-start text-font&icon-primary text-2xl font-semibold font-['DM_Sans'] leading-9">
          {t('emailConfirmed.title')}
        </div>
        <div className="self-stretch text-center justify-start text-font&icon-secondary text-base font-normal font-['DM_Sans'] leading-6">
          {t('emailConfirmed.description')}
        </div>
        <div className="pl-1.5 pr-3 py-[8px] bg-[#FFF6ED] border border-[#FFD1A9] rounded-[8px] md:rounded-full inline-flex justify-center items-start md:items-center gap-2.5">
          <div className="px-2 py-[3px] bg-[#FB6011] rounded-[360px] flex justify-start items-center">
            <div className="justify-end text-[#fff] text-[12px] font-extrabold font-['Inter'] leading-3 italic">
              Tips
            </div>
          </div>
          <div
            className={`text-sm justify-start text-[#9B2911] -mt-[2px] ${isMobile() ? '' : 'leading-4'}`}
          >
            <span className="">{t('modal.email_verification.add_email')} </span>
            <span className="underline">support@creator.aha.inc</span>
            {', '}
            <span className="underline">support@creator.headai.io</span>
            <span className="">
              {' '}
              {t('modal.email_verification.to_contacts', {
                defaultValue:
                  'to your contacts to avoid missing Aha notifications.'
              })}
            </span>
          </div>
        </div>
        <div className="mt-3">
          <div
            className="w-full !bg-[#FB6011] rounded-[8px] text-white text-center px-4 py-2 cursor-pointer"
            onClick={() => {
              navigate('/');
            }}
          >
            {t('emailConfirmed.goToAha')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmed;
